<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { Share, Copy } from 'lucide-vue-next';
import { toast } from '@/components/ui/toast';  
import { trackEvent } from '@/utils/analytics';
const LINK = 'https://booking.avee.health';
const LINK_WITH_SOURCE = LINK + '?source=review';

const copyLink = () => {
    navigator.clipboard.writeText(LINK_WITH_SOURCE);
    trackEvent('booking_link_copy', {});
    toast({
        variant: 'default',
        title: 'Successfully copied the link into your clipboard',
    });
}

const shareLink = () => {
    if ((typeof navigator.share === 'undefined' || !navigator.share)) {
        toast({
            variant: 'destructive',
            title: 'Your browser does not support native share feature. Please use the copy button to share the link.',
        });
        return;
    }
    navigator.share({
        url: LINK_WITH_SOURCE,
    });
    trackEvent('booking_link_share', {});
}
</script>

<template>
    <div>
        <div class="font-extrabold text-2xl leading-snug text-gray-900 text-balance mb-4">Every <span class="inline-block">Canadian 🇨🇦</span> Deserves Care Like This</div>
        <div class="font-medium text-lg text-gray-900 leading-snug">Please share this link with friends or family — many people need care and don’t know where to turn.</div>
        <div class="mt-10 border-2 rounded-lg flex overflow-hidden border-gray-300">
            <div class="grow flex items-center justify-center truncate">{{ LINK }}</div>
            <div class="flex items-center h-12 border-l-2 border-gray-300 px-2.5 cursor-pointer active:bg-gray-200 scale-105 transition-all duration-100 select-none" @click="copyLink">
                <Copy class="size-6 mr-2" />
                Copy
            </div>
        </div>
        <Button size="lg" class="mt-3 w-full font-bold text-lg" @click="shareLink">
            <Share class="size-6 mr-2" />
            Share
        </Button>
    </div>
</template>
